import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import App from 'app/components/root-apps/basic-app';
import { baseMapStateToProps, baseMapDispatchToProps, basePreload } from './base';

const mapStateToProps = (state, ownProps) => ({
  ...baseMapStateToProps(state, ownProps),
});

const AppContainer = connect(mapStateToProps, baseMapDispatchToProps)(preload(
  ({ dispatch, getState }) => basePreload(dispatch, getState()))(App),
);

export default AppContainer;



// WEBPACK FOOTER //
// ./app/common/containers/basic-app.js